import { create } from "zustand";

interface AuthNoticeState {
  /** A sentence for the sign-in screen: why the person is there. */
  message: string | null;
  set(message: string): void;
  clear(): void;
}

/** Why the person was signed out, shown once on the sign-in screen. */
export const useAuthNotice = create<AuthNoticeState>((set) => ({
  message: null,
  set: (message) => set({ message }),
  clear: () => set({ message: null }),
}));
